(function() {
  'use strict';

  function enforceWholeNumbers(input) {
    if (input.dataset.wholeNumbersBound) return;
    input.dataset.wholeNumbersBound = 'true';

    input.onkeypress = null;
    input.removeAttribute('onkeypress');
    input.setAttribute('step', '1');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '\\d*');

    input.addEventListener('keydown', function(e) {
      if (['.', ',', 'e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    }, true);

    input.addEventListener('input', function() {
      var cleaned = this.value.replace(/[^\d]/g, '');
      if (cleaned !== this.value) this.value = cleaned;
    });

    input.addEventListener('blur', function() {
      if (this.value !== '') {
        this.value = String(parseInt(this.value, 10) || '');
      }
    });
  }

  function scan() {
    document.querySelectorAll('input.gpo-number').forEach(enforceWholeNumbers);
  }

  function init() {
    scan();

    // Observe the whole document for Globo's late injection
    var observer = new MutationObserver(scan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    // Safety net: poll for the first 10 seconds in case the observer misses
    var attempts = 0;
    var interval = setInterval(function() {
      scan();
      attempts++;
      if (attempts >= 20) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();